
import api from '../api';
import { API_URL } from '../config';

export const getGoals = async () => {
  const res = await api.get(`${API_URL}/goals`);
  return res.data;
};

export const createGoal = async (goalData) => {
  const res = await api.post(`${API_URL}/goals`, goalData);
  return res.data;
};

export const updateGoal = async (id, goalData) => {
  const res = await api.put(`${API_URL}/goals/${id}`, goalData);
  return res.data;
};

export const deleteGoal = async (id) => {
  const res = await api.delete(`${API_URL}/goals/${id}`);
  return res.data;
};

export const getGoalStatsByContext = async () => {
  const res = await api.get(`${API_URL}/goals/stats/context`);
  return res.data;
};

export const getGoalStatsByPeriod = async (period) => {
  const res = await api.get(`${API_URL}/goals/stats/period?period=${period}`);
  return res.data;
};
